import { axiosClient } from "services/axios";

import { AddClientGroupParams, EditClientGroupParams } from "../types";

export function getClientGroups() {
  return axiosClient.get("users/client-groups").then((res) => res.data);
}

export function addClientGroup(params: AddClientGroupParams) {
  return axiosClient.post("users/client-group", params);
}

export function editClientGroup(params: EditClientGroupParams) {
  return axiosClient.put("users/client-group", params);
}

export function deleteClientGroup(clientgroupid: string) {
  return axiosClient.post("users/delete-client-group", { clientgroupid });
}
